import { FC } from "react";
import { IconProps } from "./types";

export const ArrowLeftCircleLine: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      d="M10.845 6a.58.58 0 0 0-.41.17l-5.391 5.415a.605.605 0 0 0-.126.64.581.581 0 0 0 .126.19l5.388 5.415a.595.595 0 0 0 .638.127.575.575 0 0 0 .316-.316.586.586 0 0 0-.126-.636l-4.398-4.419h11.68a.581.581 0 0 0 .583-.585.587.587 0 0 0-.583-.586H6.86l4.397-4.419A.585.585 0 0 0 10.845 6z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.61 2.721A12 12 0 1 0 4.39 21.28 12 12 0 0 0 19.61 2.72zM18.043 21.05a10.884 10.884 0 0 1-6.047 1.834A10.898 10.898 0 0 1 1.112 12.001a10.884 10.884 0 1 1 16.931 9.049z"
      fill={fill}
    />
  </svg>
);
